import React from 'react';
import { Cell } from 'react-table';
import cx from 'classnames';

import { TooltipColumn } from '@trqk/components/src/table/types';
import { defaultCellWidth } from '@trqk/components/src/table/constants';

interface DurationCellProps {
    cell: Cell<DetectionTrack>;
    column: TooltipColumn<DetectionTrack>;
}

/**
 * Displays the duration that detection has been enabled (if it is currently enabled) within a
 * tooltip. If the row contains a detection status update that is in draft mode, the text will be
 * gray.
 * @param {DurationCellProps} props
 */
export const DurationCell = ({
    cell,
    column,
}: DurationCellProps): JSX.Element => {
    const width = (column?.width as number) ?? defaultCellWidth;
    const {
        value: { label, draft },
    } = cell;

    return (
        <div
            className={cx(
                'respond-to-mouse clamp-2-lines-break-words text-xs px-1',
                {
                    'text-tertiary-400': draft,
                },
            )}
            style={{
                width,
            }}
        >
            {label}
        </div>
    );
};
